import { render, staticRenderFns } from "./PostListAll.vue?vue&type=template&id=1b9d4d25&"
import script from "./PostListAll.vue?vue&type=script&lang=js&"
export * from "./PostListAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports